import { connectToStores } from 'fluxible-addons-react';
import StaticContentStore from '../../../stores/StaticContentStore';
import { StaticPage } from './StaticPage';
export default connectToStores(StaticPage, [StaticContentStore], function (context, props) {
    var staticContentStore = context.getStore(StaticContentStore);
    return {
        url: props.currentRoute.url,
        content: staticContentStore.getContent(),
    };
});
